export default `
attribute float aDuration;
attribute vec3 aSource;
attribute vec3 aTarget;
attribute float aTimeOffset;
uniform float uTime;
varying float vProgress;
varying vec3 worldNormal;
#ifndef IS_BACKFACE
	varying vec3 viewDirection;
#endif
void main() {

	vProgress = mod(uTime + aTimeOffset, aDuration) / aDuration;
	vec3 pos = mix(aSource, aTarget, vProgress);

	vec4 transformedNormal = vec4(normal, 0.);
	vec4 transformedPosition = vec4(position + pos, 1.0);
	#ifdef USE_INSTANCING
		transformedNormal = instanceMatrix * transformedNormal;
		transformedPosition = instanceMatrix * transformedPosition;
	#endif
	#ifndef IS_BACKFACE
		vec4 worldPosition = modelMatrix * vec4( position, 1.0);
		viewDirection = normalize(worldPosition.xyz - cameraPosition);
	#endif
	
	worldNormal = normalize( modelViewMatrix * transformedNormal).xyz;
	gl_Position = projectionMatrix * modelViewMatrix * transformedPosition;
}
`
